import Cookies from 'js-cookie';
import queryString from 'query-string';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { convertStringToInteger } from 'common/helpers/numberHelper';
import { getCheckoutHref } from 'common/helpers/routerHelper';
import { addCartItem, addCoupon, updateCart } from 'redux/cart/actions';
import { createClubSignup } from 'redux/clubSignup/actions';

const UrlWidgets = () => {
  const dispatch = useDispatch();

  const qString = queryString.extract(window.location.href);
  const queryObj = queryString.parse(qString);

  const { clubSignup } = queryObj;
  const { couponCode, addToCart, checkout, quantity, c7EmailId } = queryObj;

  let isExecute = false;

  if (clubSignup && addToCart) {
    throw new Error(
      'Cant use both clubSignup and addToCart as url params at the same time'
    );
  }

  if (clubSignup) {
    const onSuccess = () => {
      window.location.href = getCheckoutHref('/club');
    };
    dispatch(createClubSignup(clubSignup, onSuccess));
  }

  let addToCartFunction = () => {};
  if (addToCart) {
    isExecute = true;
    let onSuccess = () => {
      //
    };
    if (checkout) {
      onSuccess = () => {
        window.location.href = getCheckoutHref('/cart');
      };
    }

    const q = (quantity && convertStringToInteger(quantity)) || 1;

    const item = {
      sku: addToCart,
      quantity: q
    };
    addToCartFunction = () => {
      dispatch(addCartItem(item, onSuccess));
    };
  }

  let addCouponFunction = () => {
    addToCartFunction();
  };

  if (couponCode) {
    isExecute = true;
    const errorFunction = () => {
      // fail silently
      addToCartFunction();
    };
    const onSuccess = () => {
      addToCartFunction();
    };
    addCouponFunction = () => {
      dispatch(addCoupon(couponCode, onSuccess, errorFunction));
    };
  }

  let metaDataFunction = () => {
    addCouponFunction();
  };
  if (Object.keys(queryObj).length) {
    const data = {};
    let isMeta = false;
    const metaData = {};

    // meta_ parameters
    const metaArray = Object.keys(queryObj).filter(
      (k) => k.substring(0, 4) === 'meta'
    );
    metaArray.forEach((metaElement) => {
      metaData[metaElement.substring(5)] = queryObj[metaElement];
    });

    // mailchimp parameter
    if (queryObj.mc_cid) {
      metaData.mc_cid = queryObj.mc_cid;
    }
    // facebook parameter
    if (queryObj.fbclid) {
      metaData.fbclid = queryObj.fbclid;
    }
    if (Object.keys(metaData).length) {
      isExecute = true;
      isMeta = true;
      data.metaData = metaData;
      Cookies.set('c7metaData', JSON.stringify(metaData));
    }
    if (c7EmailId) {
      isExecute = true;
      isMeta = true;
      Cookies.set('c7EmailId', c7EmailId);
      data.additionalInfo = {
        emailId: c7EmailId
      };
    }
    if (isMeta && Cookies.get('cartId')) {
      const onSuccess = () => {
        addCouponFunction();
      };
      const errorFunction = () => {
        addCouponFunction();
      };
      metaDataFunction = () => {
        dispatch(updateCart(data, onSuccess, errorFunction));
      };
    }
  }

  // Trigger to update functions
  useEffect(() => {
    if (isExecute) {
      metaDataFunction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExecute]);

  return null;
};

export default UrlWidgets;
